module.exports = __webpack_public_path__ + "4665c6c45c8231c9eacd5c2b0a72379c.svg";